<template>
    <component
        v-if="isValidValue"
        :is="typeTag"
        class="l-ss-c-price"
        :class="typePrice">
        <span
            v-if="isFormattedObject"
            class="l-ss-c-price-digit-full">
            {{ formattedValue[0] }},
            <span class="l-ss-c-price-digit-after">{{ formattedValue[1] }}</span>
            {{ formattedValue[2] }}
        </span>
        <span
            v-else
            class="l-ss-c-price-digit-full">
            {{ formattedValue }}
        </span>
        <i
            v-if="useCurrencyIcon"
            v-html="currencyIcon"
            class="l-ss-c-icon l-ss-c-price-icon"></i>
    </component>
</template>

<script>
    import { currencyAsString, getCurrencyIcon } from '@/core/helpers/display';
    import priceFormatMixin from '@/core/mixins/price-format-mixin';

    export default {
        mixins: [priceFormatMixin],
        props: {
            tag: {
                type: String,
                default: 'strong',
            },
            isOld: {
                type: Boolean,
                default: false,
            },
            value: {
                type: [Number, String],
                default: '',
            },
            currency: {
                type: String,
                default: 'RUB',
                required: false,
            },
        },
        computed: {
            typeTag() {
                return this.isOld ? 's' : this.tag;
            },
            typePrice() {
                return { 'l-ss-c-price-old': this.isOld };
            },
            isValidValue() {
                return (this.value || this.value === 0);
            },
            isFormattedObject() {
                return typeof this.format(this.value) === 'object';
            },
            formattedValue() {
                return this.isFormattedObject ? this.format(this.value) : this.format(this.value);
            },
            currencyIcon() {
                return getCurrencyIcon(this.currency);
            },
            useCurrencyIcon() {
                return Boolean(this.currencyIcon && navigator.userAgent.indexOf('Windows NT 6.1') !== -1);
            },
        },
        methods: {
            format(value) {
                if (!value) {
                    return ' - ';
                }
                const valueRounded = this.getRoundedPrice(value);
                return this.useCurrencyIcon ?
                    valueRounded.toString().replaceAll(/[^\d\s\\.,]/g, '').trim() :
                    currencyAsString(valueRounded, this.currency, this);
            },
        },
    };
</script>